<template>
  <button @click="$emit('click')"  class="btn" v-bind:style="btnStyle" ref="btnElement" >
    <slot></slot>
  </button>
</template>

<script>
import ColorUtils from "../utils/ColorUtils";

// Then do props

export default {
  components: {},
  computed: {
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },

    btnStyle() {
      var colorUtils = new ColorUtils();

      var btnTextColor = this.$store.getters["GET_MAIN_UI"].button_text_color;
      var btnBackgroundColor = this.$store.getters["GET_MAIN_UI"].button_color;

      return {
        "--button-color": btnBackgroundColor,
        "--button-background-color": "#FFFFFF",
        "--button-color--hover": btnBackgroundColor,
        "border-color" : btnBackgroundColor
      };
    }
  }
};
</script>


<style lang="scss" scoped>
button {
  color: var(--button-color);
  background-color: var(--button-background-color);
}

button:hover {
  color: var(--button-color);
  filter: brightness(95%);
}
button:active {
  filter: brightness(90%);
}
</style>